import BannerService from '@engoo/banner-service';
import { getBackendPath } from 'app/utils/paths';

// Instantiate an instance of the banner service.
export const createBannerService = (config: { api: string } = { api: `${getBackendPath()}/api` }) => {
  return new BannerService(config);
};
